import { render } from "./StatsBuilder.vue?vue&type=template&id=8ceaf4d0&scoped=true"
import script from "./StatsBuilder.vue?vue&type=script&lang=ts"
export * from "./StatsBuilder.vue?vue&type=script&lang=ts"

import "./StatsBuilder.vue?vue&type=style&index=0&id=8ceaf4d0&lang=scss"
import "./StatsBuilder.vue?vue&type=style&index=1&id=8ceaf4d0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-8ceaf4d0"

export default script